// @core/api/endpoints/payment/resolve_payment_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolvePaymentContextRequest,
  ResolvePaymentContextResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Resolve payment context
 * Resolves effective payment policy, available providers, and routes for a scope entity.
 */
export async function ResolvePaymentContext(
  data: ResolvePaymentContextRequest,
  options?: RequestOptions
): Promise<ResolvePaymentContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payment/resolve-context`;
  const requestOptions = options;
  return client.post<ResolvePaymentContextResponse>(requestPath, data, requestOptions);
}
